class WishlistTrigger extends HTMLElement {
  connectedCallback () {
    this.trigger = this.querySelector('[data-wishlist-trigger-el="button"]')
    this.socialCountEl = this.querySelector('[data-wishlist-trigger-el="socialCount"]')
    this.inWishlist = false
    this.showWishlistCount = this.dataset.showCount === 'true'
console.log('wish', this.showWishlistCount)
    if (!this.trigger) return

    this.setupListeners()
    this.updateState()
    if (this.showWishlistCount) {
      this.initSocialCount()
    }
  }

  setupListeners () {
    window.addEventListener(window.theme.wishlist.eventBus.wishlist_added_product, (event) => {
      if (Number(event.detail.empi) !== Number(this.dataset.productId)) return

      this.updateState(true)
      this.trigger.setAttribute('aria-pressed', 'true')
      if (this.showWishlistCount) {
        this.adjustSocialCount(1)
      }
    })

    window.addEventListener(window.theme.wishlist.eventBus.wishlist_removed_product, (event) => {
      if (Number(event.detail.empi) !== Number(this.dataset.productId)) return

      this.updateState(false)
      this.trigger.setAttribute('aria-pressed', 'false')
      if (this.showWishlistCount) {
        this.adjustSocialCount(-1)
      }
    })

    this.trigger.addEventListener('click', this.handleClick.bind(this))
  }

  async updateState (knownState = null) {
    await window.theme.wishlist.readyPromise
    await window.theme.wishlist.wishlistPromise

    if (knownState !== null) {
      this.inWishlist = knownState
    } else {
      const wishlist = await window.theme.wishlist.fetchWishlist()

      this.inWishlist = wishlist?.items.some(product => product.empi === Number(this.dataset.productId)) || false
    }

    this.setAttribute('data-wishlist-added', this.inWishlist)
    this.trigger.setAttribute('aria-pressed', this.inWishlist)
    this.setAttribute('aria-busy', 'false')
  }

  initSocialCount () {
    if (!this.socialCountEl) return

    this.socialCountPromise = window.theme.wishlist
      .fetchSocialCount(this.dataset.productId, this.dataset.productUrl)
      .then(count => this.renderSocialCount(count))
  }

  async adjustSocialCount (delta) {
    if (!this.socialCountEl) return

    await this.socialCountPromise

    this.renderSocialCount(Math.max(0, this.socialCount + delta))
  }

  renderSocialCount (count) {
    this.socialCount = count
    this.socialCountEl.textContent = count > 0 ? new Intl.NumberFormat(document.documentElement.lang || undefined, { notation: 'compact' }).format(count) : ''
    this.socialCountEl.hidden = count === 0
  }

  handleClick () {
    this.setAttribute('aria-busy', 'true')

    const eventType = this.inWishlist
      ? window.theme.wishlist.eventBus.wishlist_remove_product
      : window.theme.wishlist.eventBus.wishlist_add_product

    const event = new CustomEvent(eventType, {
      detail: {
        productId: this.dataset.productId,
        variantId: this.dataset.variantId,
        productUrl: this.dataset.productUrl,
        productTitle: this.dataset.productTitle,
        productPrice: this.dataset.productPrice,
      },
    })

    window.dispatchEvent(event)
  }
}

customElements.define('wishlist-trigger', WishlistTrigger)
